<template lang="pug">
	component(v-bind="linkProps(to)")
		slot
</template>

<script>
export default {
	props: {
		to: {
			type: String,
			required: true
		}
	},
	methods: {
		linkProps (url) {
			if (url.match(/^(http(s)?|ftp):\/\//)) {
				return {
					is: 'a',
					href: url,
					target: '_self',
					rel: 'noopener'
				}
			}
			return {
				is: 'router-link',
				to: url
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/components/app-link.vue